var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.146 9.074C9.3162 8.54724 9.62892 8.07788 10.0495 7.71795C10.4701 7.35802 10.9821 7.12157 11.5289 7.03479C12.0756 6.94802 12.6357 7.01432 13.147 7.22634C13.6584 7.43836 14.1011 7.78782 14.426 8.236C14.7513 8.68353 14.9466 9.21231 14.9901 9.76388C15.0337 10.3155 14.9238 10.8683 14.6727 11.3614C14.4217 11.8544 14.0391 12.2684 13.5675 12.5576C13.0958 12.8468 12.5533 12.9999 12 13V14M12.05 17V17.1H11.95V17H12.05ZM3 17.8V6.2C3 5.08 3 4.52 3.218 4.092C3.41 3.715 3.715 3.41 4.092 3.218C4.52 3 5.08 3 6.2 3H17.8C18.92 3 19.48 3 19.907 3.218C20.284 3.41 20.59 3.715 20.782 4.092C21 4.519 21 5.079 21 6.197V17.804C21 18.922 21 19.481 20.782 19.908C20.59 20.2845 20.2837 20.5904 19.907 20.782C19.48 21 18.921 21 17.803 21H6.197C5.079 21 4.519 21 4.092 20.782C3.71569 20.5903 3.40974 20.2843 3.218 19.908C3 19.48 3 18.92 3 17.8Z",
    stroke: "#548170",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.df93df655563622e900dd56acb92cd20.svg";
export { ForwardRef as ReactComponent };